// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__2CEiD","title":"ClientCherryInfo_title__1tFe8","itemText":"ClientCherryInfo_itemText__2V7IG"};